import { useAuthenticatedUser } from "@/hooks/use-authenticated-user";

export const useBusinessReportAdmin = () => {
  const { features } = useAuthenticatedUser();
  return features.includes("business_report_admin") || features.includes("superadmin");
};
